import { render, staticRenderFns } from "./DefaultTemplate.vue?vue&type=template&id=1f906c9e&scoped=true"
import script from "./DefaultTemplate.vue?vue&type=script&lang=js"
export * from "./DefaultTemplate.vue?vue&type=script&lang=js"
import style0 from "./DefaultTemplate.vue?vue&type=style&index=0&id=1f906c9e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f906c9e",
  null
  
)

export default component.exports